import React from 'react'
import PropTypes from 'prop-types'

const SuccessHubSubtitle = ({ className }) => (
  <h6 className={className} data-no-translate translate="no">
    Success Hub
  </h6>
)

SuccessHubSubtitle.propTypes = {
  className: PropTypes.string.isRequired,
}

export default SuccessHubSubtitle
